<div class="container">

    <h1 class="fw-light text-center text-lg-start mt-4 mb-0" translate>dishes_gallery_title</h1>
  
    <hr class="mt-2 mb-5">
    
        <div class="row text-center text-lg-start">

        <div class="col-lg-3 col-md-4 col-6" *ngFor="let url of urls">
            <a href="#" class="d-block mb-4 h-100" (click)="select($event)">
            <img class="img-fluid img-thumbnail" src="{{url}}" alt="">
            </a>
        </div>
    </div>
  </div>